// import echarts from "echarts";
// import * as echarts from "echarts";
export function loadChart(myChart, seriesData, legendData, unit) {
  if (myChart) {
    myChart.clear();
  }
  if (seriesData.length > 0) {
    var colorList = [
      "#73DDFF",
      "#73ACFF",
      "#FDD56A",
      "#FDB36A",
      "#FD866A",
      "#9E87FF",
      "#58D5FF"
    ];
    // 设置
    myChart.setOption({
      title: {
        text: "",
        x: "center",
        y: "center",
        textStyle: {
          color: "#fff"
        }
      },
      tooltip: {
        trigger: "item",
        borderColor: "rgba(255,255,255,.3)",
        backgroundColor: "rgba(13,5,30,.6)",
        borderWidth: 1,
        padding: 5,
        textStyle: {
          color: "#fff"
        },
        formatter: function(parms) {
          var str =
            parms.marker +
            "" +
            parms.data.name +
            "</br>" +
            "数量：" +
            parms.data.value +
            "</br>" +
            "占比：" +
            parms.percent +
            "%";
          return str;
        }
      },
      legend: {
        show: false,
        type: "scroll",
        orient: "vertical",
        left: "10",
        align: "auto",
        top: "40",
        textStyle: {
          color: "#fff"
        },
        data: legendData
      },
      series: [
        {
          type: "pie",
          z: 3,
          center: ["53%", "54%"],
          radius: ["25%", "50%"],
          clockwise: true,
          avoidLabelOverlap: true,
          hoverOffset: 15,
          itemStyle: {
            normal: {
              color: function(params) {
                return colorList[params.dataIndex];
              }
            }
          },
          label: {
            show: true,
            position: "outside",
            // formatter: "{a|{b}：{d}%}\n{hr|}",
            formatter: "{a|{b}：{c}}" + "(" + unit + ")",
            textStyle: {
              color: "#fff"
            },
            rich: {
              hr: {
                backgroundColor: "#18c0e0",
                borderRadius: 3,
                width: 3,
                height: 3,
                padding: [3, 3, 0, 0]
              },
              a: {
                // padding: [-10, 15, -20, 15]
                padding: [0, 0, 0, 0]
              }
            }
          },
          labelLine: {
            normal: {
              length: 20,
              length2: 20,
              lineStyle: {
                width: 1
              }
            }
          },
          data: seriesData
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
